import { Store } from 'vuex'

import { JudgeReferenceModuleName, RecentJudgeListModuleName } from './modules/modules'

import { RootState } from '.'

import { JudgeRecord } from '@/domain/entities/judge/judgeRecord'
import { convertJudgeStatusType } from '@/domain/value_objects/judge/JudgeStatusType'
import { programLanguageList, ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'

export const createJudgeResultSocket = (socketBuilder: () => WebSocket) => {
  let lastJudgeId = 0
  let lastJudgeStatus = ''
  let isProcessing = false
  const messageQueue: MessageEvent[] = []

  const processQueue = async (store: Store<RootState>) => {
    if (isProcessing || messageQueue.length === 0) {
      return
    }

    isProcessing = true
    try {
      const event = messageQueue.shift()!
      const judgeRecord = parseRecentJudges(JSON.parse(event.data))

      if (judgeRecord.judgeId === lastJudgeId && judgeRecord.status === lastJudgeStatus) return

      await store.commit(`${RecentJudgeListModuleName}/pushRecentJudgeList`, { judgeRecord }, { root: true })

      await store.dispatch(`${JudgeReferenceModuleName}/handleJudgeRecord`, { judgeRecord }, { root: true })

      lastJudgeId = judgeRecord.judgeId
      lastJudgeStatus = judgeRecord.status
    } finally {
      isProcessing = false
      // 次のメッセージがキューにある場合は処理を継続
      if (messageQueue.length > 0) {
        await processQueue(store)
      }
    }
  }

  return (store: Store<RootState>) => {
    let socket = socketBuilder()

    const onMessage = (e: MessageEvent) => {
      messageQueue.push(e)
      processQueue(store).catch(console.error)
    }

    const onError = () => {
      socket.close()
    }

    const onClose = () => {
      setTimeout(() => {
        socket = socketBuilder()
        socket.onmessage = onMessage
        socket.onerror = onError
        socket.onclose = onClose
      }, 1000)
    }

    socket.onmessage = onMessage
    socket.onerror = onError
    socket.onclose = onClose
  }
}

const isProgramLanguage = (lang: any): lang is ProgramLanguageType => {
  if (lang) {
    return false
  }
  return programLanguageList.includes(`${lang}` as ProgramLanguageType)
}

export const parseRecentJudges = (data: any): JudgeRecord => {
  const recentJudge: JudgeRecord = {
    accuracy: 'accuracy' in data ? data.accuracy : '',
    codeSize: 'code' in data ? data.code : 0,
    contestId: 'contestID' in data ? data.contestID : '',
    cpuTime: 'cputime' in data ? data.cputime : 0,
    judgeDate: 'judgeDate' in data ? new Date(data.judgeDate) : new Date(),
    judgeId: 'runID' in data ? data.runID : 0,
    judgeType: 'judgeType' in data ? data.judgeType : 0,
    programLanguage: isProgramLanguage(data.lang) ? data.lang : `${data.lang}`,
    memory: 'memory' in data ? data.memory : 0,
    problemId: 'problemID' in data ? data.problemID : '',
    problemTitle: 'problemTitle' in data ? data.problemTitle : null,
    score: 'score' in data ? data.score : null,
    status: convertJudgeStatusType(data.status),
    submissionDate: 'submissionDate' in data ? new Date(data.submissionDate) : new Date(),
    token: 'token' in data ? data.token : null,
    userId: 'userID' in data ? data.userID : ''
  }

  return recentJudge
}
